import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { costs } from '../data/copy';
export function ProblemSection() {
  return <section className="defer-paint w-full bg-paper-soft py-14 sm:py-20" aria-labelledby="problem-heading" data-id="element-175" data-mp="2lqgwkp38r9v5">
      <div className="mx-auto max-w-5xl px-6" data-id="element-176" data-mp="2vqhdk4dn1dw6">
        <SectionHeading eyebrow="Il problema reale" eyebrowTone="rust" title={<span id="problem-heading" data-id="element-178" data-mp="39hcqpsv66h5k">Ti suona familiare?</span>} data-id="element-177" data-mp="2vpplv4n5w0b6" />

        <div className="mx-auto mt-10 max-w-3xl space-y-5 border-l-4 border-pine pl-6 sm:pl-8" data-id="element-179" data-mp="39jqo48dbo5ga">
          <p className="font-display text-2xl font-semibold leading-snug text-ink sm:text-3xl" data-id="element-180" data-mp="35in6bgbprzcf">
            Sono le 18:00. Tra poco inizia l'allenamento.
          </p>
          <p className="font-sans text-base leading-relaxed text-ink-muted" data-id="element-181" data-mp="3ehidovqhvfhb">
            Hai davanti giocatori con livelli diversi, palloni da distribuire,
            uno spazio da organizzare e 60 minuti da sfruttare bene.
          </p>
          <p className="font-sans text-base leading-relaxed text-ink-muted" data-id="element-182" data-mp="jd3nknzxobrf">
            Sai che oggi vuoi lavorare sul passaggio. Sul tiro. Sul cambio di
            direzione. Sull'1 contro 1.
          </p>
          <p className="font-sans text-base leading-relaxed text-ink-muted" data-id="element-183" data-mp="se1t5aq0src4">
            Ma manca ancora una cosa:
          </p>
          <p className="font-display text-2xl font-bold uppercase tracking-wide text-rust sm:text-3xl" data-id="element-184" data-mp="x5juhzvygtxm">
            Una progressione chiara.
          </p>
          <p className="font-sans text-base leading-relaxed text-ink-muted" data-id="element-185" data-mp="125z3kf97ff9s">
            Apri il telefono. Cerchi un esercizio. Poi un altro. Salvi un video.
            Modifichi le distanze. Adatti il numero di giocatori.
          </p>
          <p className="font-sans text-base leading-relaxed text-ink-muted" data-id="element-186" data-mp="1g3nsby6e76k4">
            Provi a ricordare cosa avevi fatto nella seduta precedente.
          </p>
          <p className="font-display text-xl font-semibold leading-snug text-ink sm:text-2xl" data-id="element-187" data-mp="3hur3cok72n57">
            E quando finalmente inizi… hai una serie di esercizi, ma non
            necessariamente un allenamento costruito con logica.
          </p>
        </div>

        <div className="mt-16" data-id="element-188" data-mp="k2qofqln2b1s">
          <h3 className="text-center font-display text-2xl font-bold uppercase leading-tight text-pine sm:text-3xl" data-id="element-189" data-mp="k3imr96memvr">
            Il costo reale di non avere il sistema corretto
          </h3>

          <ul className="mt-7 grid gap-x-10 gap-y-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-190" data-mp="u1q0lj5m4otj">
            {costs.map(cost => <li key={cost.title} className="flex gap-3.5" data-id="element-191" data-mp="17ws4k0qwg43p">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-rust" aria-hidden="true" data-id="element-192" data-mp="12z8mepr2z76h">
                  <XIcon className="h-3.5 w-3.5 text-paper-soft" strokeWidth={3} data-id="element-193" data-mp="1hqr2enjxx1pu" />
                </span>
                <span data-id="element-194" data-mp="1cs7h8pd67tyj">
                  <span className="block font-display text-lg font-semibold leading-snug text-ink" data-id="element-195" data-mp="1qp3019j84zrs">
                    {cost.title}
                  </span>
                  <span className="mt-1 block font-sans text-sm leading-snug text-ink-muted" data-id="element-196" data-mp="1logebxdoeghi">
                    {cost.detail}
                  </span>
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}